import { ModalCustom } from "components/ModalCustom";
import { useEffect, useState } from "react";
import { Form } from "react-bootstrap";
import { Required } from "components/Required";
import { Controller, useForm } from "react-hook-form";
import { PrimaryButton } from "components/Button/style";
import { yupResolver } from "@hookform/resolvers/yup";
import { DropdownSelect } from "components/DropdownSelect";
import { CustomInput } from "components/CustomInput";
import { ContainerForm, ContainerInstrucoes } from "./style";
import { useMaskInput } from "hooks/useMaskInput";
import { IAdicionarCusto } from "../../../interface/IAdicionarCusto";
import { adicionarCustoSchema } from "../../../validate/adicionarCusto.schema";
import { IOptionsProcessoFinanceiroDescricao } from "hooks/useProcessoFinanceiroDescricao";
import { Informacao } from "components/Informacao";
import { FaExclamationCircle } from "react-icons/fa";

interface Props {
  show: boolean;
  handleClose: () => void;
  onSubmit: (dados: IAdicionarCusto) => void;
  idFornecedor: number;
  listarOptions: (idFornecedor?: number) => any;
  processosFinanceirosDescricoesOptions: IOptionsProcessoFinanceiroDescricao[];
}

export function ModalAdicionarCusto({
  show,
  handleClose,
  onSubmit,
  idFornecedor,
  listarOptions,
  processosFinanceirosDescricoesOptions,
}: Props) {
  const { mInputCoin } = useMaskInput();
  const [valorEscolhido, setValorEscolhido] = useState<string>("");

  const {
    handleSubmit,
    control,
    reset,
    setValue,
    formState: { errors },
  } = useForm({
    resolver: yupResolver(adicionarCustoSchema),
  });

  useEffect(() => {
    if (show) {
      listarOptions(idFornecedor);
      setValorEscolhido("");
      setValue("valor", "");
      setValue("servico", 0);
    }
  }, [show]);

  const onChangeServico = (idDescricao: number) => {
    if (!idDescricao) {
      setValorEscolhido("");
      setValue("valor", "");
      return;
    }

    const arrayServico = processosFinanceirosDescricoesOptions.filter(
      (servico) => servico.value == idDescricao
    );

    if (arrayServico.length) {
      const valor = String(arrayServico[0].valorServico ?? "");

      setValorEscolhido(valor);

      setValue("valor", valor, {
        shouldValidate: true,
        shouldDirty: true,
      });
    }
  };

  return (
    <ModalCustom
      show={show}
      handleClose={handleClose}
      title="Detalhes do serviço"
      centered
    >
      <ContainerInstrucoes>
        Preencha as informações do custo que deseja adicionar aos processos
        selecionados.
      </ContainerInstrucoes>
      <Informacao
        mensagem="Só é possível incluir serviços financeiros previamente cadastrados para o fornecedor selecionado na criação do lote"
        type="atencao"
        showBotaoFechar={false}
        showLabel={false}
        icone={<FaExclamationCircle />}
      />
      <form
        onSubmit={handleSubmit((dados: IAdicionarCusto) => {
          onSubmit(dados);
        })}
      >
        <ContainerForm>
          <Form.Group style={{ marginTop: 15 }}>
            <Form.Label>
              Custo <Required />
            </Form.Label>
            <Controller
              control={control}
              name="servico"
              render={({ field: { onChange, value } }) => (
                <DropdownSelect
                  options={processosFinanceirosDescricoesOptions}
                  title=""
                  selectedValue={value}
                  onSelect={(e) => {
                    onChange(e);
                    onChangeServico(e);
                  }}
                  searchable
                  mensagemErro={errors.servico?.message}
                />
              )}
            />
          </Form.Group>
          <Form.Group style={{ marginTop: 15 }}>
            <Form.Label>
              Valor <Required />
            </Form.Label>
            <Controller
              control={control}
              name="valor"
              render={({ field: { onChange, value } }) => (
                <CustomInput
                  type="text"
                  placeholder="Informe o valor"
                  style={{ height: "2.2rem" }}
                  value={value ?? ""}
                  onChange={(e: any) => {
                    const rawValue = e.target.value.replace(/[^0-9.]/g, "");
                    const masked = mInputCoin({
                      ...e,
                      target: { ...e.target, value: rawValue },
                    });

                    setValorEscolhido(masked);
                    onChange(masked);
                  }}
                  mensagemErro={errors.valor?.message}
                  isInvalid={!!errors.valor}
                />
              )}
            />
          </Form.Group>
        </ContainerForm>
        <div className="d-flex justify-content-end gap-4 mt-4">
          <PrimaryButton
            style={{ width: "10rem" }}
            outline
            variante="primary"
            onClick={handleClose}
            type="button"
          >
            Cancelar
          </PrimaryButton>
          <PrimaryButton
            style={{ width: "10rem" }}
            type="submit"
            disabled={!valorEscolhido || valorEscolhido === "0.00"}
          >
            Incluir
          </PrimaryButton>
        </div>
      </form>
    </ModalCustom>
  );
}
